// Quiz time estimate — DERIVED from the live question count, never hardcoded.
//
// 2026-08-20 (McKayla Loom "Current Site Feedback Part 3" t=1:59). Both quiz
// intro blocks in pages/quiz.tsx read "Est. time to complete: 2 minutes" above
// a 29-question assessment. Her words: "estimated time to complete two minutes
// is not accurate. This took me like 15 minutes to even, and I quit halfway
// through because it was annoying me."
//
// This lives in its own module so the production page and its test share ONE
// definition. An earlier version of the test re-implemented the arithmetic,
// which meant changing the real rate here would have left the test green.
//
// The rate is calibrated to McKayla's own stated target for the reworked quiz:
// 15 questions in a five-minute experience (2026-08-20 call, "I would like to
// get it to an experience that takes five minutes"), i.e. 20 seconds per
// question. That makes the estimate self-correcting — when her content rework
// cuts the quiz to 15 questions it will read 5 minutes with no code change.
export const SECONDS_PER_QUESTION = 20;

/**
 * Whole-minute estimate for a quiz of `totalQuestions` questions.
 * Never returns less than 1 minute.
 *
 * Took a second `specificCount` argument until 2026-08-20, when the
 * sub-personality quiz was removed (ClickUp 86bb0f9vz). There is now exactly
 * one question list, so a second parameter would be a dead concept that reads
 * as if a second block still exists. Callers pass the live question count.
 */
export const estimatedQuizMinutes = (totalQuestions: number): number =>
  Math.max(1, Math.round((totalQuestions * SECONDS_PER_QUESTION) / 60));
